import React from "react";

const PeopleSingleSmall = () => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13.9183C1 8.38101 13.1551 8.38101 13.1551 13.778"
        stroke="var(--efficeTitlePresence-color)"
        strokeWidth="1.99157"
      />
      <circle
        cx="7.21421"
        cy="4.61502"
        r="2.78581"
        stroke="var(--efficeTitlePresence-color)"
        strokeWidth="1.99157"
      />
    </svg>
  );
};

export default PeopleSingleSmall;
